import { DatePickerButtonComponent } from './date-picker-button.component';

export const DatePickerButtonModule = angular
  .module('sfMobile.components.date-picker-button', [])
  .component('sfDatePickerButton', DatePickerButtonComponent).name;
